module.exports = __webpack_public_path__ + "static/Pt33-removebg-preview-81e9c7b0ff3b1c0e888dbfb2a1e1b07e.png";